export const NO_CACHE_HEADERS = { pragma: 'no-cache', 'cache-control': 'no-cache' }
